import { render, staticRenderFns } from "./cgu_eticket.vue?vue&type=template&id=1cfc2d2a&scoped=true"
import script from "./cgu_eticket.vue?vue&type=script&lang=js"
export * from "./cgu_eticket.vue?vue&type=script&lang=js"
import style0 from "./cgu_eticket.vue?vue&type=style&index=0&id=1cfc2d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc2d2a",
  null
  
)

export default component.exports